import { Autocomplete, Grid, TextField } from "@mui/material";
import React, { useContext } from "react";

import { PosContext } from "../../shared/PosContext";

const CustomerDetails = ({ formData, setFormData }) => {
    const { territoryOptions } = useContext(PosContext);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    return (
        <Grid container spacing={3}>
            <Grid item xs={12} sm={6}>
                <TextField
                    className="CustomerInput"
                    required
                    id="customer_name"
                    name="customer_name"
                    label="Customer Name"
                    value={formData.customer_name}
                    onChange={handleChange}
                    fullWidth
                    autoComplete="given-name"
                />
            </Grid>
            <Grid item xs={12} sm={6}>
                <TextField
                    className="CustomerInput"
                    required
                    id="mobile_no"
                    name="mobile_no"
                    label="mobile_no"
                    type="tel"
                    value={formData.mobile_no}
                    onChange={handleChange}
                    fullWidth
                />
            </Grid>
            {/* <Grid item xs={12} sm={6}>
                <TextField
                    className="CustomerInput"
                    id="email_id"
                    name="email_id"
                    label="Email"
                    type="email"
                    value={formData.email_id}
                    onChange={handleChange}
                    fullWidth
                />
            </Grid> */}
            <Grid item xs={12} sm={12}>
                <TextField
                    className="CustomerInput"
                    required
                    id="address_line1"
                    name="address_line1"
                    label="Address Line 1"
                    value={formData.address_line1}
                    onChange={handleChange}
                    fullWidth
                />
            </Grid>
            <Grid item xs={12} sm={12}>
                <TextField
                    className="CustomerInput"
                    id="address_line2"
                    name="address_line2"
                    label="Address Line 2"
                    value={formData.address_line2}
                    onChange={handleChange}
                    fullWidth
                />
            </Grid>
        </Grid>
    );
};

export default CustomerDetails;
